import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p385415151426322432',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
